export default __webpack_public_path__ + "static/media/NotoSans-Thin.7a561ac9.woff";